/**
 * Cloud V2 — Complete The Look
 * 3 quadrados independentes: cada um tem o seu próprio carrossel automático
 * (timer e índice isolados), com fade e loop infinito. Hover/touch pausa
 * apenas o timer daquele quadrado. Clicar em qualquer quadrado, em qualquer
 * momento, adiciona ao carrinho o produto Shopify associado ao item
 * atualmente visível nesse quadrado (via /cart/add.js), com um toast de
 * feedback. Vanilla JS, sem dependências.
 */
(function () {
  'use strict';

  function refreshCartCount() {
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('.cloud-header__cart-count').forEach((badge) => {
          badge.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(() => null);
  }

  function showToast(section, message, isError) {
    const toast = section.querySelector('#cloud-look-toast') || section.querySelector('.cloud-look__toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.toggle('cloud-look__toast--error', !!isError);
    toast.hidden = false;
    toast.classList.add('cloud-look__toast--visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(() => {
      toast.classList.remove('cloud-look__toast--visible');
      setTimeout(() => { toast.hidden = true; }, 250);
    }, 2200);
  }

  function initSquare(square, section) {
    const frames = Array.from(square.querySelectorAll('[data-look-frame]'));
    if (!frames.length) return;

    /* ---------------- autoplay independente deste quadrado ---------------- */
    if (frames.length > 1) {
      const seconds = parseFloat(square.getAttribute('data-autoplay-seconds')) || 4.5;
      let current = frames.findIndex((f) => f.classList.contains('cloud-look__frame--active'));
      if (current < 0) current = 0;
      let timer = null;

      const goTo = (index) => {
        const next = ((index % frames.length) + frames.length) % frames.length;
        if (next === current) return;
        frames[current].classList.remove('cloud-look__frame--active');
        frames[current].setAttribute('aria-hidden', 'true');
        frames[next].classList.add('cloud-look__frame--active');
        frames[next].setAttribute('aria-hidden', 'false');
        current = next;
      };

      const stop = () => { if (timer) clearInterval(timer); timer = null; };
      const start = () => { stop(); timer = setInterval(() => goTo(current + 1), seconds * 1000); };

      square.addEventListener('mouseenter', stop);
      square.addEventListener('mouseleave', start);
      square.addEventListener('touchstart', stop, { passive: true });
      square.addEventListener('touchend', start, { passive: true });

      start();
    }

    /* ---------------- clique = adicionar ao carrinho ---------------- */
    function addActiveToCart() {
      const activeFrame = square.querySelector('.cloud-look__frame--active') || frames[0];
      const variantId = activeFrame.getAttribute('data-variant-id');

      if (!variantId) {
        showToast(section, 'Este item ainda não tem um Produto Shopify associado.', true);
        return;
      }

      square.classList.add('cloud-look-item--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then((r) => {
          if (!r.ok) return r.json().then((err) => Promise.reject(err));
          return r.json();
        })
        .then(() => refreshCartCount())
        .then(() => {
          showToast(section, 'Adicionado ao carrinho ✓', false);
        })
        .catch((err) => {
          showToast(section, (err && err.description) || 'Não foi possível adicionar ao carrinho.', true);
        })
        .finally(() => {
          square.classList.remove('cloud-look-item--loading');
        });
    }

    square.addEventListener('click', addActiveToCart);
    square.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        addActiveToCart();
      }
    });
  }

  function initLook(section) {
    const squares = section.querySelectorAll('[data-look-square]');
    squares.forEach((square) => initSquare(square, section));
  }

  function init() {
    document.querySelectorAll('.cloud-look').forEach(initLook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-inicializa quando o Personalizar tema recarrega a secção.
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.cloud-look');
    if (section) initLook(section);
  });
})();
